import React from 'react'
import PropTypes from 'prop-types'
import PackageSelector from '../../components/PackageSelector'

export default function PackageSelectorWrapper({title, enableDocenteCode = false}) {
    return (
        <PackageSelector
            title={title}
            groupsTitle="Pacchetto"
            turnsTitle="Seleziona periodo"
            enableStructures
            enableTurnPrice
            enableDocenteCode={enableDocenteCode}
        />
    )
}

PackageSelectorWrapper.propTypes = {
    title: PropTypes.string,
}
